import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import BannerHomePage from './BannerHomePage.js';
import AccordionCarouselBannerData from '../../../Models/Content/AccordionCarouselBannerBlockData';

export default class AccordionCarouselBannerBlock extends EpiComponent<AccordionCarouselBannerData> {

  public render(): ReactNode | ReactNodeArray | null {
    const cssClasses: Array<string> = ['accordion-and-carousel-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <BannerHomePage
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};

